export default {
    api_url: process.env.REACT_APP_DATA_API_ENDPOINT,

  }